module.exports = __webpack_public_path__ + "fonts/Roboto-Italic.c606cbef.ttf";